import { SlideComponentHkcsEnQ1 } from '@/types/slide';
import { SlideComponentCreator } from './factory';

export class SlideComponentHkcsEnQ1Creator extends SlideComponentCreator {
    public create(id: string): SlideComponentHkcsEnQ1 {
        return {
            id: id,
            type: 'hkcsEnQ1',
            pos: {
                x: 0,
                y: 0,
            },
            size: {
                width: 200,
                height: 200,
            },
            content: {
                phrase: '',

                image: '',
                imageURL: '',
                flip: 1,
                audio: [],
            },
        };
    }
}
